const MB_ImageCropperConstants = {
  COLOR: {
    darkerGray: '#717171',
    plum: '#9A4C95',
  },
};

export { MB_ImageCropperConstants };
